import styled from 'styled-components';

const StyledMedicalLeaveFormColumn = styled.div`
   flex: 1;
`;
StyledMedicalLeaveFormColumn.displayName = 'StyledMedicalLeaveFormColumn';

export { StyledMedicalLeaveFormColumn };
